
const router_modular = [
    {
        path: '/',
        name: 'share',
        component: () => import('@/views')
    },
    {
        path: '/select',
        name: 'card select',
        component: () => import('@/views/CardSelect.vue')
    },{
        path: '/apply',
        name: 'card apply',
        component: () => import('@/views/CardApply.vue')
    },{
        path: '/applyStep',
        name: 'card apply step',
        component: () => import('@/views/CardApplyStep.vue')
    },{
        path: '/resultFeedback',
        name: 'result feedback',
        component: () => import('@/views/ResultFeedback.vue')
    },{
        path: '/statusQuery',
        name: 'Application Status Inquiry',
        component: () => import('@/views/ApplicationStatusInquiry.vue')
    },
]
export default router_modular
